import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Link,
  Text,
  useColorModeValue,
  Container,
  VStack,
  Avatar,
  FormControl,
  FormLabel,
  Input,
  Button,
  Flex,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateProfileInfo,
  uploadProfileImg,
} from "../../../redux/actions/user/UserActions";
import { RootStore } from "../../../redux/Store";
import { useToast } from "@chakra-ui/react";
import moment from "moment";

import {
  CLEAR_ERROR_MESSAGE,
  CLEAR_MESSAGE,
} from "../../../redux/types/user/UserActionTypes";
import DeactivateAccountModal from "./DeactivateAccountModal";
const Profile = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [userData, setuserData] = useState<IuserData>({});
  const [updateClickState, setupdateClickState] = useState(false);
  const [uploadImageState, setuploadImageState] = useState(false);
  const toast = useToast();
  const dispatch = useDispatch();
  const userState = useSelector((state: RootStore) => state.user);
  const uiState = useSelector((state: RootStore) => state.ui);

  const [file, setfile] = useState<any>();
  const errorMsg = "This field must not be empty";

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setfile(event.target.files[0]);
    }
  };
  const handleProfileUpdate = () => {
    setupdateClickState(true);
    if (validation()) {
      const updateUserData = {
        firstName: userData.firstName,
        lastName: userData.lastName,
        address: userData.address,
      };
      dispatch(updateProfileInfo(updateUserData));
    }
  };
  const validation = (): boolean => {
    let isValid = true;

    if (
      !userData.firstName ||
      !userData.lastName ||
      !userData.address ||
      userData.address === "Add Your Address"
    ) {
      isValid = false;
    }

    return isValid;
  };
  const handleImageSubmit = () => {
    setuploadImageState(true);
    if (file) {
      const imageData = new FormData();
      imageData.append("profilePicture", file);
      dispatch(uploadProfileImg(imageData));
    }
  };
  useEffect(() => {
    setuserData({
      firstName: userState.loggedInUserData?.user?.firstName,
      lastName: userState.loggedInUserData?.user?.lastName,
      address: userState.loggedInUserData?.user?.address,
    });
    if (uploadImageState) {
      if (userState.loggedInUserData?.message) {
        toast({
          title: "Profile Picture.",
          description: userState.loggedInUserData?.message,
          status: "success",
          duration: 2000,
          isClosable: true,
        });
        dispatch({ type: CLEAR_MESSAGE });
      } else if (userState.loggedInUserData?.errMessage) {
        toast({
          title: "Error",
          description: userState.loggedInUserData?.errMessage,
          status: "error",
          duration: 2000,
          isClosable: true,
        });
        dispatch({ type: CLEAR_ERROR_MESSAGE });
      }
      setuploadImageState(false);
    } else if (updateClickState) {
      if (userState.loggedInUserData?.message) {
        toast({
          title: "User Details",
          description: userState.loggedInUserData?.message,
          status: "success",
          duration: 2000,
          isClosable: true,
        });
        dispatch({ type: CLEAR_MESSAGE });
      } else if (userState.loggedInUserData?.errMessage) {
        toast({
          title: "Error",
          description: userState.loggedInUserData?.errMessage,
          status: "error",
          duration: 2000,
          isClosable: true,
        });
        dispatch({ type: CLEAR_ERROR_MESSAGE });
      }
      setupdateClickState(false);
    }
  }, [userState.loggedInUserData]);

  return (
    <Container maxW={"7xl"} p="12" id="profileContainer" paddingBottom="3">
      <Box
        display="flex"
        flexDirection={{ base: "column", sm: "row" }}
        justifyContent="space-between"
      >
        <Box display="flex" flex="0.5" alignItems="center">
          <Avatar
            size="2xl"
            name={
              userState.loggedInUserData?.user?.firstName +
              " " +
              userState.loggedInUserData?.user?.lastName
            }
            src={userState.loggedInUserData?.user?.profilePicture}
          />{" "}
        </Box>
        <Box display="flex" flex="1" alignItems="center" marginRight="3">
          <VStack alignItems="left">
            <FormControl id="profilePictureControl">
              <FormLabel>Select Profile Picture</FormLabel>
              <Input
                type="file"
                background="white"
                id="profilePicture"
                name="profilePicture"
                onChange={handleFileChange}
                required
              />
            </FormControl>
            <Button
              bg={"blue.400"}
              isLoading={uiState.loading && uploadImageState}
              loadingText="Uploading Picture"
              color={"white"}
              width="fit-content"
              onClick={handleImageSubmit}
              id="updateButton"
              _hover={{
                bg: "blue.500",
              }}
              _focus={{
                outline: "none",
                boxShadow: "none",
                textDecor: "none",
              }}
            >
              {" "}
              Change Profile Picture
            </Button>
          </VStack>
        </Box>
        <Box
          display="flex"
          flex="2"
          flexDirection="column"
          justifyContent="center"
          marginTop={{ base: "3", sm: "0" }}
        >
          <Heading marginTop="1">
            <Link textDecoration="none" _hover={{ textDecoration: "none" }}>
              My Details
            </Link>
          </Heading>
          <Text
            as="p"
            marginTop="2"
            color={useColorModeValue("gray.700", "gray.200")}
            fontSize="lg"
          >
            Firstname - {userState.loggedInUserData?.user?.firstName}
          </Text>
          <Text
            as="p"
            marginTop="2"
            color={useColorModeValue("gray.700", "gray.200")}
            fontSize="lg"
          >
            Lastname - {userState.loggedInUserData?.user?.lastName}
          </Text>
          <Text
            as="p"
            marginTop="2"
            color={useColorModeValue("gray.700", "gray.200")}
            fontSize="lg"
          >
            Email - {userState.loggedInUserData?.user?.email}
          </Text>
          <Text
            as="p"
            marginTop="2"
            color={useColorModeValue("gray.700", "gray.200")}
            fontSize="lg"
          >
            Address - {userState.loggedInUserData?.user?.address}
          </Text>
          <Text
            as="p"
            marginTop="2"
            color={useColorModeValue("gray.700", "gray.200")}
            fontSize="lg"
          >
            Joined At -{" "}
            {moment(userState.loggedInUserData?.user?.createdAt).format(
              "DD MMMM YYYY"
            )}
          </Text>
        </Box>
      </Box>
      <Flex align={"center"} justify={"center"} marginTop="10">
        <Box
          rounded={"md"}
          boxSize="inherit"
          bg={useColorModeValue("blue.50", "gray.800")}
          boxShadow={"md"}
          height="fit-content"
          width="100%"
          textAlign="center"
          p={5}
        >
          <Stack align={"center"}>
            <Heading fontSize={"4xl"} textAlign="center">
              Update your details
            </Heading>
          </Stack>
          <Stack spacing={2}>
            {/* <chakra.form> */}
            <FormControl id="firstNameControl">
              <FormLabel>First Name</FormLabel>
              <Input
                type="text"
                isInvalid={
                  updateClickState ? !userData.firstName && true : false
                }
                value={userData.firstName}
                onChange={(event) => {
                  setuserData({ ...userData, firstName: event.target.value });
                }}
                background="white"
                id="firstName"
                name="firstName"
              />
              {updateClickState && !userData.firstName && (
                <Text fontSize="xs" color="red" marginTop="3px" align="left">
                  {errorMsg}
                </Text>
              )}
            </FormControl>
            <FormControl id="lastNameControl">
              <FormLabel>Last Name</FormLabel>
              <Input
                type="text"
                isInvalid={
                  updateClickState ? !userData.lastName && true : false
                }
                value={userData.lastName}
                onChange={(event) => {
                  setuserData({ ...userData, lastName: event.target.value });
                }}
                background="white"
                id="lastName"
                name="lastName"
              />
              {updateClickState && !userData.lastName && (
                <Text fontSize="xs" color="red" marginTop="3px" align="left">
                  {errorMsg}
                </Text>
              )}
            </FormControl>
            <FormControl id="addressControl">
              <FormLabel>Address</FormLabel>
              <Input
                type="text"
                placeholder="Add Your Address"
                isInvalid={
                  updateClickState
                    ? (!userData.address ||
                        userData.address === "Add Your Address") &&
                      true
                    : false
                }
                value={
                  userData.address === "Add Your Address"
                    ? ""
                    : userData.address
                }
                onChange={(event) => {
                  setuserData({ ...userData, address: event.target.value });
                }}
                background="white"
                id="address"
                name="address"
              />
              {updateClickState &&
                (!userData.address ||
                  userData.address === "Add Your Address") && (
                  <Text fontSize="xs" color="red" marginTop="3px" align="left">
                    {errorMsg}
                  </Text>
                )}
            </FormControl>

            <Stack spacing={4}>
              <Button
                bg={"blue.400"}
                isLoading={uiState.loading && updateClickState}
                loadingText="Updating"
                color={"white"}
                onClick={handleProfileUpdate}
                width="fit-content"
                id="updateDetailsButton"
                _hover={{
                  bg: "blue.500",
                }}
                _focus={{
                  outline: "none",
                  boxShadow: "none",
                  textDecor: "none",
                }}
              >
                Update Details
              </Button>
            </Stack>
            {/* </chakra.form> */}
          </Stack>
        </Box>
      </Flex>
      <Box
        display="flex"
        flex="0.5"
        flexDirection="column"
        align={"center"}
        justify={"center"}
        marginTop={{ base: "3", sm: "3" }}
      >
        <Button
          bg={"#D10024"}
          color={"white"}
          width="fit-content"
          onClick={onOpen}
          id="deactivateAccount"
          align={"center"}
          margin={"auto"}
          _hover={{
            bg: "red.500",
          }}
          _focus={{
            outline: "none",
            boxShadow: "none",
            textDecor: "none",
          }}
        >
          {" "}
          Deactivate Account
        </Button>
        <DeactivateAccountModal isOpen={isOpen} onClose={onClose} />
      </Box>
    </Container>
  );
};

export default Profile;
